import script from "./InsetIconSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./InsetIconSwitch.vue?vue&type=script&setup=true&lang=js"

import "./InsetIconSwitch.vue?vue&type=style&index=0&id=1aeda515&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aeda515"]])

export default __exports__